import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "./components/ScrollToTop";
import ErrorBoundary from "./components/ErrorBoundary";
import Login from "./pages/login";
import Signup from "./pages/signup";
import Dashboard from "./pages/dashboard";
import DeveloperDashboard from "./pages/developer-dashboard";
import EmailTemplateGenerator from "./pages/email-template-generator";
import ContractUpload from "./pages/contract-upload";
import ContractHistory from "./pages/contract-history";
import ContractAnalysisResults from "./pages/contract-analysis-results";
import ContractSummaryPage from "./pages/contract-summary";
import SharePage from "./pages/share";
import CalendarEventPage from "./pages/calendar-event";
import NotFound from "./pages/NotFound";


const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
      <ScrollToTop />
      <RouterRoutes>
        {/* Define your routes here */}
        <Route path="/" element={<ContractUpload />} />
        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/developer-dashboard" element={<DeveloperDashboard />} />
        <Route path="/email-template-generator" element={<EmailTemplateGenerator />} />
        <Route path="/contract-upload" element={<ContractUpload />} />
        <Route path="/contract-history" element={<ContractHistory />} />
        <Route path="/contract-analysis-results" element={<ContractAnalysisResults />} />
        <Route path="/contract/:dealId" element={<ContractSummaryPage />} />
        <Route path="/preview-email/:dealId" element={<EmailTemplateGenerator />} />
        <Route path="/share/:shareId" element={<SharePage />} />
        <Route path="/e/:dealId" element={<CalendarEventPage />} />
        <Route path="*" element={<NotFound />} />
      </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;
